module.exports = __webpack_public_path__ + "static/img/pr.0811a051.svg";